import React from 'react';
import { FormControl, Box, TextField, Autocomplete } from '@mui/material';

interface Option {
  value: string;
  label: string;
}

interface MerchantNameFieldProps {
  field: any;
  form: any;
  merchantOptions: Option[];
  disabled?: boolean;
}

const MerchantNameField: React.FC<MerchantNameFieldProps> = ({ field, form, merchantOptions, disabled }) => {
  const hasError = form.touched[field.name] && Boolean(form.errors[field.name]);
  const value = merchantOptions.find((opt) => opt.value === field.value) || null;

  return (
    <FormControl fullWidth sx={{ width: '401px' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Autocomplete
          options={merchantOptions}
          getOptionLabel={(option) => option.label}
          value={value}
          onChange={(_, newValue) => {
            form.setFieldValue(field.name, newValue ? newValue.value : '');
            form.setFieldTouched(field.name, true, false);
          }}
          disabled={disabled}
          renderInput={(params) => (
            <TextField
              {...params}
              error={hasError}
              placeholder="Select Merchant"
              sx={{
                mb: 0,
                '& .MuiInputBase-root': {
                  fontSize: 14,
                  color: 'text.primary',
                  width: '401px',
                  height: '40px',
                },
                '& .MuiFormLabel-root': {
                  fontSize: 14,
                },
              }}
              helperText={hasError ? form.errors[field.name] : ''}
            />
          )}
        />
      </Box>
    </FormControl>
  );
};

export default React.memo(MerchantNameField); 